export default __webpack_public_path__ + "static/media/plusIconCircle.de647647.svg";